<template>
    <vs-chip class="ag-grid-cell-chip" :color="chipColor(params.value)">
      <span>{{ params.value }}</span>
    </vs-chip>
</template>

<script>
export default {
  name: 'cellRendererTransactionsType',
  computed: {
    chipColor () {
      return (value) => {
        if (value === 'Deposit') return 'success'
        if (value === 'Withdrawal') return 'danger'
        else return 'primary'
      }
    }
  }
}
</script>